import { IHistoryFreeType, IHistoryNiche, IHistoryTag, IHistoryUser } from "@/common/services/types";
import { TagCard } from "../TagCard";
import { ProfileCard } from "../ProfileCard";
import { NicheCard } from "../NicheCard";
import { FreeTextCard } from "../FreeTextCard";
import { useSearchHistoryItem } from "./hooks/useSearchHistoryItem";

interface ISearchHistoryItem {
  data: IHistoryUser | IHistoryFreeType | IHistoryNiche | IHistoryTag;
}

export const SearchHistoryItem = ({ data }: ISearchHistoryItem) => {
  const { handleClick } = useSearchHistoryItem();

  switch (data.type) {
  case "tag": {
    const { tag } = data as IHistoryTag;

    if (!tag) {
      return null;
    }

    return (
      <TagCard
        tagName={tag.name}
        qty={tag.count}
        onClick={() => handleClick(tag.name)}
      />
    );
  }
  case "user": {
    const { account: { verified, studio, followers, name, username, profileImageUrl } } = data as IHistoryUser;
    return (
      <ProfileCard
        verified={verified}
        followers={followers}
        userName={name}
        profileImageUrl={profileImageUrl}
        isStudio={!!studio}
        userId={username}
        hasSubscribeMsg
        onClick={() => handleClick(name)}
      />
    );
  }
  case "niche": {
    const { niche: { id, subscribers, thumbnail, name } } = data as IHistoryNiche;
    return (
      <NicheCard
        id={id}
        nicheImageUrl={thumbnail}
        followers={subscribers}
        nicheName={name}
        onClick={() => handleClick(name)}
      />
    );
  }
  case "free_type": {
    const { value } = data as IHistoryFreeType;
    return (
      <FreeTextCard
        text={value}
        onClick={() => handleClick(value)}
      />
    );
  }
  default: {
    return null;
  }
  }
};
